module.exports = __webpack_public_path__ + "618d1f5be2a48100f4836e11ecfc2022.pdf";